export function sizer(...nums: number[]): string {
  return nums.map((num) => `${num / 4}rem`).join(" ");
}
